import React from 'react';
import { useTranslation } from 'react-i18next';

export default function SearchDrink(props) {
    const { className, categories, setResult, setIsSearching } = props;

    const { t } = useTranslation();

    function search(e) {
        if (typeof e.target.value === "string" && e.target.value !== "") {
            const target = e.target.value.toLowerCase();
            let result = [];

            categories.forEach(category => {
                const drinks = category.drinks.filter(drink => drink.name.includes(target));
                if (drinks.length > 0) {
                    result.push({ drinks, name: category.name });
                }
            });

            setResult(result);
            setIsSearching(true);
        } else {
            setResult(categories);
            setIsSearching(false);
        }
    };

    return (
        <div>
            <input
                className={className}
                placeholder={t("searchdrink.input")}
                onChange={search} />
        </div>
    );
}
